export default {
    addChatSession: function (eventId, chatSession) {
        return {type: 'CHAT_ADD_SESSION', eventId, chatSessionId: chatSession.id, chatSession};
    },
    updateActiveSessions: (activeSessions, fetchTime) => ({
        type: 'CHAT_UPDATE_ACTIVE_SESSIONS',
        activeSessions,
        fetchTime,
    }),
    updateMessages: (chatId, messages) => ({type: 'CHAT_UPDATE_MESSAGES', chatId, messages}),
    markAllAsRead: chatId => ({type: 'CHAT_MARK_ALL_AS_READ', chatId}),
};
